import { Button, Tooltip } from 'antd';
import React from 'react';
import "./buttons.css";

const SecondaryButton = ({buttonText, handleOnClick, buttonDisable, icon, tooltipTitle, invitationForm, loading}) => {
  return (
    <>
      <Tooltip title={tooltipTitle}>
        <Button className={`secondary-btn ${invitationForm ? "invitation-button" : ""}`} onClick={handleOnClick} disabled={buttonDisable} icon={icon} loading={loading}>{buttonText}</Button>
      </Tooltip>
    </>
  )
}

export default SecondaryButton;